import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "Aug 2022 - Feb 2023",
      title: "Developer Full Stack",
      place: "Oracle Next Education",
      desc: "Building web pages, applications and websites,HTML, DOM, Javascript, Java POO, CSS, Flexbox, Grid, responsive design, CRUD, JSON, API, validations, CSS architecture, Oracle cloud, SQL trainig with MySQL from Oracle.",
    },
    {
      yearRange: "Aug 2022 - Oct 2022",
      title: "Java Full Stack",
      place: "Generation México",
      desc: "Website building, code optimization, front-end, back-end, databases, HTML, Bootstrap, CSS, API, MySQL, Spring Boot, JavaScript, Java, React, Git and Github.",
    },
    {
      yearRange: "Jan 2017 - Dec 2021",
      title: "Mechatronics Engineering",
      place: "Universidad Tecnológica de Tecámac",
      desc: "Structured programming, object-oriented programming, design and construction of control systems, 3D modeling, application and microcontroller programming, C++, C, Python, Java and SQL.",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "Aug 2022 - Oct 2022",
      title: "Jr. Java Full Stack",
      place: "Generation México",
      desc: "I participated in the creation of a new website with the help of SCRUM methodology, trello, discord and figma. I worked on the front-end, back-end and databases.",
    },
    {
      yearRange: "Mar 2021 - Jul 2022",
      title: "CNC Programmer",
      place: "Freelancer",
      desc: "I operated and programmed CNC equipment. I selected and optimized resources. Designed and manufactured products. I used G Code programming, 2D and 3D modeling in softwares such as SOLIDWORKS, AutoCAD, Adobe Illustrator.",
    },
    {
      yearRange: "May 2019 - Aug 2019",
      title: "Programming and Project Automation Intern",
      place: "Hamacas Viky",
      desc: "I designed automatic control system for weaving machine. I design with softwares and handling of test tools and implementation of electronic circuit, programmed in C language.",
    },
  ];


  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-blanco px-2">Curriculum</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of My Resume
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          {/* My Education */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 translate="no" className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          {/* My Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 translate="no" className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>

        
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
        <div className="featured-box text-center px-md-4 ">
            <div className="featured-box-icon text-red text-13 iconos-resume fadeInUp">
            <div data-tooltip="HTML, CSS, JavaScript" >
              <img 
                className="img-icon-resume"
                src="images/css.svg"
                alt="css"
              />
            </div>
            <div data-tooltip="Sass">
                <img
                  src="images/sass.svg"
                  alt="sass"
                />
            </div>
            
            <div data-tooltip="React">
                <img
                  src="images/react.svg"
                  alt="react"
                />
            </div>
            <div data-tooltip="Bootstrap">
                <img
                  src="images/bt.svg"
                  alt="bootstrap"
                />
            </div>
            <div data-tooltip="Java">
                <img
                  src="images/java.svg"
                  alt="java"
                />
            </div>
            <div data-tooltip="Python">
                <img
                  src="images/python.svg"
                  alt="python"
                />
            </div>
            <div data-tooltip="PHP">
                <img
                  src="images/php.svg"
                  alt="php"
                />
            </div>
            <div data-tooltip="Spring">
                <img
                  src="images/springio-icon.svg"
                  alt="Spring"
                />
            </div>
            
            <div data-tooltip="GitHub">
                <img
                  src="images/git.svg"
                  alt="github"
                />
            </div>
            <div data-tooltip="Git">
                <img
                  src="images/gitt.svg"
                  alt="git"
                />
            </div>
            <div data-tooltip="SQL, MySQL">
                <img
                  src="images/bd.svg"
                  alt="base de datos"
                />
            </div>
            
            </div>          
        </div>
        
              

        <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download CV
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
